import React from "react";
import "./styles/Info.css";
import Slide from "react-reveal/Slide";
const Info = ({ texto, imagen }) => {
  return (
    <>
      {" "}
      <div className="c-info">
        <div className="info-img">
          <img src={imagen} alt={texto} className="img-fit" />
        </div>
        <div className="info-text">
          <p className="">{texto}</p>
        </div>
      </div>
    </>
  );
};

export default Info;
